webpackJsonp([75],{

/***/ 1333:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1334);


/***/ }),

/***/ 1334:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(170);

var _datetime2 = _interopRequireDefault(_datetime);

var _it = __webpack_require__(774);

var _it2 = _interopRequireDefault(_it);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('it', _it2.default);

/***/ })

},[1333]);


// WEBPACK FOOTER //
// app/datetime.it-a1f1e88a702f767c1080.js